<template>
    <div class="messages mt-20 animated slideInRight" v-if="showMessages">
        <template v-if="messages.messages[2][0]">
            <div type="alert alert-dismissible alert-success">
                <button type="button" class="close" data-dismiss="alert">&times;</button>
                <p><strong>Success</strong></p><template v-for="(msg, index) in messages.messages[2]"><p :key="index">- {{msg}}</p></template>
            </div>
        </template>
        <template v-if="messages.messages[1][0]">
            <div class="alert alert-dismissible alert-info">
                <button type="button" class="close" data-dismiss="alert">&times;</button>
                <p><strong>Info</strong></p><template v-for="(msg, index) in messages.messages[1]"><p :key="index">- {{msg}}</p></template>
            </div>
        </template>
        <template v-if="messages.messages[0][0]">
            <div class="alert alert-dismissible alert-danger">
                <button type="button" class="close" data-dismiss="alert">&times;</button>
                <p><strong>Error</strong></p><template v-for="(msg, index) in messages.messages[0]"><p :key="index">- {{msg}}</p></template>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'Messages',
        props: ['messages'],
        data () {
            return { }
        },
        methods: {
            closeMessages: function () {
                this.messages.clearMessages()
            }
        },
        computed: {
            showMessages: function () {
                if (this.messages.messages[0][0] || this.messages.messages[1][0] || this.messages.messages[2][0]) {
                    return true
                }
                return false
            }
        }
    }
</script>

<style lang="scss"></style>
